import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import LayerPopup from './LayerPopup';
import { errorCode } from '../CommonFunction'

const LogoutBtn2 = () => {
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState(null)
    const logout = () => {
        axios.post(`/webauthn/users/signout`, { withCredentials: true }).then(function (res) {

            if (res.data.code !== 0) {
                const message = errorCode(res.data.code)
                setErrorMessage(message)
                return
            } else {
                navigate("/")
            }

        }).catch(function (err) {
            setErrorMessage('취소 되었습니다.')
            return;
        })
    }

    return (
        <>
            <button className='logout' onClick={() => { logout() }}>로그아웃</button>
            {errorMessage && <LayerPopup text={errorMessage} onClose={() => setErrorMessage(null)}></LayerPopup>}
        </>
    );
};

export default LogoutBtn2;